module.exports = __webpack_public_path__ + "images/ff4848bb95da8ab3172da4cba9e2a4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/RCPStrengths/img/expertise-metier.jpg
// module id = 1385
// module chunks = 0